import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import Block from 'ap-admin-components/lib/Components/Block';
import Link from 'next/link';
import { Overlays } from 'ap-admin-components/lib/Components/Overlays';
import { AuthContext } from '@/auth/Authentication';
import { translationNamespace } from '@/lib/config';
import MainMenu from '@/layout/header/MainMenu';
import { ChannelContext } from '@/components/channel/Channel';
import ChannelSelect from '@/components/channel/ChannelSelect';
import LanguageSelect from '@/components/language/LanguageSelect';
import styles from './styles.module.scss';

const UserInfo: React.FC = () => {
  const { t } = useTranslation(translationNamespace);
  const { logout, user } = useContext(AuthContext);
  const { overlaysActions } = useContext(Overlays);
  if (!user) {
    return null;
  }
  return (
    <div className={styles['header__user']}>
      <div className={styles['header__user__details']}>
        <p>{user.name}</p>
        <p>{user.preferred_username}</p>
      </div>
      <LanguageSelect />
      <button
        className={styles['header__button']}
        onClick={() => {
          void logout();
          overlaysActions({
            action: 'close',
            name: 'all',
          });
        }}
      >
        {t('logout')}
      </button>
    </div>
  );
};

const Header = () => {
  const { t } = useTranslation(translationNamespace);
  const { isAuthenticated } = useContext(AuthContext);
  const { channelId, channel } = useContext(ChannelContext);

  return (
    <Block
      theme="light"
      className={styles['header']}
    >
      <div className={styles['header__row1']}>
        <Link
          href={isAuthenticated ? `/${channelId}/outlets` : '/'}
          className="logo"
          aria-label={t('title')}
        >
          {channel?.logo && channel.label && (
            <img
              src={channel.logo}
              width={135}
              height={40}
              alt={channel.label}
            />
          )}
        </Link>
        <ChannelSelect />
        <UserInfo />
      </div>
      {isAuthenticated && (
        <div className={styles['header__row2']}>
          <MainMenu />
        </div>
      )}
    </Block>
  );
};

export default Header;
